(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c-comparison-table"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const carousel = document.querySelector('.c-comparison-table__carousel-wrapper');
    const dots = document.querySelectorAll('.c-comparison-table__dot');

    if (!carousel || dots.length === 0) return;

    let currentIndex = 0;
    const slides = carousel.querySelectorAll('.c-comparison-table__carousel-slide');
    const totalSlides = slides.length;

    // Only enable carousel functionality below 1050px
    function checkMobile() {
      return window.innerWidth <= 1050;
    }

    if (checkMobile()) {
      // Update dots based on scroll position
      function updateDots() {
        const scrollLeft = carousel.scrollLeft;
        const slideWidth = slides[0]?.offsetWidth || 0;
        const newIndex = Math.round(scrollLeft / slideWidth);

        if (newIndex !== currentIndex && newIndex < totalSlides && newIndex >= 0) {
          currentIndex = newIndex;
          dots.forEach((dot, index) => {
            if (index === currentIndex) {
              dot.classList.add('c-comparison-table__dot--active');
            } else {
              dot.classList.remove('c-comparison-table__dot--active');
            }
          });
        }
      }

      // Dot click handler
      dots.forEach((dot, index) => {
        dot.addEventListener('click', function() {
          const slideWidth = slides[0]?.offsetWidth || 0;
          const scrollPosition = index * slideWidth;
          carousel.scrollTo({
            left: scrollPosition,
            behavior: 'smooth'
          });
          currentIndex = index;
          updateDots();
        });
      });

      // Update dots on scroll
      carousel.addEventListener('scroll', updateDots);

      // Initial dot update
      updateDots();

      // Update on resize
      let resizeTimeout;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
          if (checkMobile()) {
            updateDots();
          }
        }, 250);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-testimonials"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const wrapper = document.querySelector('.c-testimonials-wrapper');
    const dots = document.querySelectorAll('.c-testimonials-dot');
    
    if (!wrapper || dots.length === 0) return;

    let currentIndex = 0;
    const cards = wrapper.querySelectorAll('.c-testimonial-card');
    const totalCards = cards.length;

    // Only enable carousel functionality on mobile/tablet
    function checkMobile() {
      return window.innerWidth <= 1172;
    }

    if (checkMobile()) {
      // Update dots based on scroll position
      function updateDots() {
        const scrollLeft = wrapper.scrollLeft;
        const cardWidth = cards[0]?.offsetWidth || 0;
        const gap = 16; // 1rem gap on mobile
        const newIndex = Math.round(scrollLeft / (cardWidth + gap));
        
        if (newIndex !== currentIndex && newIndex < totalCards && newIndex >= 0) {
          currentIndex = newIndex;
          dots.forEach((dot, index) => {
            if (index === currentIndex) {
              dot.classList.add('c-testimonials-dot--active');
            } else {
              dot.classList.remove('c-testimonials-dot--active');
            }
          });
        }
      }

      // Dot click handler
      dots.forEach((dot, index) => {
        dot.addEventListener('click', function() {
          const cardWidth = cards[0]?.offsetWidth || 0;
          const gap = 16;
          const scrollPosition = index * (cardWidth + gap);
          wrapper.scrollTo({
            left: scrollPosition,
            behavior: 'smooth'
          });
          currentIndex = index;
          updateDots();
        });
      });

      // Update dots on scroll
      wrapper.addEventListener('scroll', updateDots);

      // Initial dot update
      updateDots();

      // Update on resize
      let resizeTimeout;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
          if (checkMobile()) {
            updateDots();
          }
        }, 250);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function() {
    function styleFollowShopButton() {
      const followButtons = document.querySelectorAll('shop-follow-button');
      
      followButtons.forEach(function(button) {
        const shadowRoot = button.shadowRoot;
        if (!shadowRoot) return;
        
        // Inject style element into shadow DOM if not already present
        let styleElement = shadowRoot.querySelector('style[data-follow-shop-custom]');
        if (!styleElement) {
          styleElement = document.createElement('style');
          styleElement.setAttribute('data-follow-shop-custom', 'true');
          styleElement.textContent = `
            button,
            button *,
            button span,
            button div,
            button .text-white,
            button .text-gray-500,
            button .text-gray-400,
            button [class*="text-"] {
              color: #000000 !important;
              background-color: transparent !important;
            }
            button {
              background-color: #FFFFFF !important;
              color: #000000 !important;
              border: 1px solid #000000 !important;
            }
            button:hover,
            button:hover *,
            button:hover span,
            button:hover div,
            button:hover .text-white,
            button:hover .text-gray-500,
            button:hover .text-gray-400,
            button:hover [class*="text-"] {
              color: #000000 !important;
              background-color: transparent !important;
            }
            button:hover {
              background-color: #F5F5F5 !important;
              color: #000000 !important;
            }
            button:focus,
            button:focus *,
            button:focus span,
            button:focus div,
            button:focus .text-white,
            button:focus .text-gray-500,
            button:focus .text-gray-400,
            button:focus [class*="text-"] {
              color: #000000 !important;
              background-color: transparent !important;
            }
            button:focus {
              background-color: #F5F5F5 !important;
              color: #000000 !important;
            }
          `;
          shadowRoot.appendChild(styleElement);
        }
        
        // Also apply inline styles as backup
        const buttonElement = shadowRoot.querySelector('button');
        if (buttonElement) {
          buttonElement.style.backgroundColor = '#FFFFFF';
          buttonElement.style.color = '#000000';
          buttonElement.style.border = '1px solid #000000';
          
          // Style all text elements inside the button
          const textElements = buttonElement.querySelectorAll('*');
          textElements.forEach(function(el) {
            el.style.color = '#000000';
          });
          
          // Remove transparent background class if present
          buttonElement.classList.remove('bg-transparent');
        }
      });
    }
    
    // Run immediately
    styleFollowShopButton();
    
    // Run when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', styleFollowShopButton);
    }
    
    // Run after delays to catch dynamically loaded buttons
    setTimeout(styleFollowShopButton, 500);
    setTimeout(styleFollowShopButton, 1000);
    setTimeout(styleFollowShopButton, 2000);
    setTimeout(styleFollowShopButton, 3000);
    
    // Continuous check for a few seconds to ensure styles are applied
    let checkCount = 0;
    const maxChecks = 10;
    const checkInterval = setInterval(function() {
      styleFollowShopButton();
      checkCount++;
      if (checkCount >= maxChecks) {
        clearInterval(checkInterval);
      }
    }, 300);
    
    // Watch for new buttons being added
    const observer = new MutationObserver(function(mutations) {
      let shouldStyle = false;
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && (node.tagName === 'SHOP-FOLLOW-BUTTON' || node.querySelector && node.querySelector('shop-follow-button'))) {
              shouldStyle = true;
            }
          });
        }
      });
      if (shouldStyle) {
        setTimeout(styleFollowShopButton, 100);
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-icons"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tickerList = document.querySelector('[data-ticker-list]');
    if (!tickerList) return;
    
    let isPaused = false;
    let animationId = null;
    let setWidth = 0;
    let scrollPosition = 0;
    const speed = 0.8; // pixels per frame (lower = slower, higher = faster)
    
    // Calculate the width of one complete set of items
    function calculateSetWidth() {
      const items = tickerList.querySelectorAll('.c-ticker__item');
      const totalItems = items.length;
      
      // We have 3 sets (original + 2 duplicates)
      const itemsPerSet = Math.floor(totalItems / 3);
      
      if (itemsPerSet === 0 || totalItems < itemsPerSet * 3) return 0;
      
      // Most reliable method: measure the actual distance from start of first item to start of first item in second set
      const firstItem = items[0];
      const firstItemOfSecondSet = items[itemsPerSet];
      
      if (firstItem && firstItemOfSecondSet) {
        // Get bounding rects relative to the list container
        const listRect = tickerList.getBoundingClientRect();
        const firstItemRect = firstItem.getBoundingClientRect();
        const secondSetFirstRect = firstItemOfSecondSet.getBoundingClientRect();
        
        // Calculate positions relative to the list
        const firstItemLeft = firstItemRect.left - listRect.left;
        const secondSetLeft = secondSetFirstRect.left - listRect.left;
        
        // The width of one set is the distance from first item start to second set first item start
        // This automatically includes all gaps and spacing
        const calculatedWidth = secondSetLeft - firstItemLeft;
        
        if (calculatedWidth > 0) {
          return calculatedWidth;
        }
      }
      
      // Fallback: calculate manually by summing item widths and gaps
      let width = 0;
      const computedStyle = window.getComputedStyle(tickerList);
      
      // Get gap value
      let gapValue = 0;
      const gap = computedStyle.gap || computedStyle.columnGap;
      if (gap && gap !== 'normal') {
        gapValue = parseFloat(gap) || 0;
      }
      
      // Calculate width of first set including gaps
      for (let i = 0; i < itemsPerSet; i++) {
        const item = items[i];
        if (item) {
          const itemRect = item.getBoundingClientRect();
          const itemWidth = itemRect.width;
          width += itemWidth;
          
          // Add gap between items (not after the last item)
          if (i < itemsPerSet - 1 && gapValue > 0) {
            width += gapValue;
          }
        }
      }
      
      return width;
    }
    
    function animate() {
      if (!isPaused && setWidth > 0) {
        scrollPosition -= speed;
        
        // Seamlessly loop: when we scroll past one complete set, reset back by one set width
        // This creates an invisible loop since the duplicate sets are identical
        // Handle negative numbers properly for seamless looping
        if (Math.abs(scrollPosition) >= setWidth) {
          scrollPosition = scrollPosition + setWidth;
        }
        
        tickerList.style.transform = `translate3d(${scrollPosition}px, 0, 0)`;
      }
      
      animationId = requestAnimationFrame(animate);
    }
    
    // Initialize
    function init() {
      const newWidth = calculateSetWidth();
      if (newWidth > 0 && newWidth !== setWidth) {
        setWidth = newWidth;
        // Reset position to start of first set
        scrollPosition = 0;
        tickerList.style.transform = `translate3d(0, 0, 0)`;
        
        if (!animationId) {
          animationId = requestAnimationFrame(animate);
        }
      }
    }
    
    // Wait for layout and styles to be fully applied
    setTimeout(init, 100);
    setTimeout(init, 400);
    setTimeout(init, 800);
    
    // Pause on hover
    const ticker = document.querySelector('.c-ticker');
    if (ticker) {
      ticker.addEventListener('mouseenter', function() {
        isPaused = true;
      });
      
      ticker.addEventListener('mouseleave', function() {
        isPaused = false;
      });
    }
    
    // Update on resize
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        init();
      }, 250);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ticker"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const featuresTicker = document.querySelector('.ticker');
    if (featuresTicker) {
      const emblaNode = document.querySelector('.ticker.embla');
      const options = {
        loop: true,
        align: 'start',
        watchDrag: false,
      };
      const plugins = [
        EmblaCarouselAutoScroll({
          playOnInit: true,
          speed: 1.5,
          startDelay: 0,
          stopOnInteraction: false,
          stopOnMouseEnter: true,
        }),
      ];
      const emblaApi = EmblaCarousel(emblaNode, options, plugins);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
